import React from "react";
import styled from "styled-components";
import { BASIC_BLACK, BASIC_DARK_GRAY } from "../../../constants/colors";
import { CloseButton } from "../../atoms/CloseButton";
import { Link } from "../../atoms/Link";
import { PopupModalContainer, fadein } from "./PopupModal.styles";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
};

export const ContactUsModal: React.FC<Props> = ({ isOpen, handleClose }) => {
  if (!isOpen) return null;

  return (
    <PopupModalContainer $isOpen={isOpen}>
      <ModalContainer $isOpen={isOpen}>
        <CloseButton onClick={handleClose}></CloseButton>

        <ModalTitle>
          ご注文に関するお問い合わせは
          <br />
          ご注文された店舗に直接お電話に
          <br />
          ご連絡をお願い致します
        </ModalTitle>

        <ModalSubtitleContainer>
          <ModalSubtitle>
            <Link
              underline
              fontWeight={200}
              newTab
              external
              fontSize="14px"
              color={BASIC_BLACK}
              text="当社へのご意見・ご要望は"
              href={"https://www.joyfull.co.jp/contact/index"}
            />
          </ModalSubtitle>
          <ModalSubtitle>
            <Link
              underline
              fontWeight={200}
              newTab
              external
              fontSize="14px"
              color={BASIC_BLACK}
              text="こちらから、お願い致します"
              href={"https://www.joyfull.co.jp/contact/index"}
            />
          </ModalSubtitle>
        </ModalSubtitleContainer>
      </ModalContainer>
    </PopupModalContainer>
  );
};

const ModalContainer = styled.div<{ $isOpen: boolean }>`
  max-width: 390px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 85%;
  background-color: white;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transform: ${({ $isOpen }) =>
    $isOpen
      ? "translate(-50%, -50%) scale(1, 1)"
      : "translate(-50%, -50%) scale(0.9, 0.9)"};
  padding: 40px 30px;
  animation: ${fadein} 0.5s forwards;
`;

const ModalTitle = styled.div`
  padding: 0;
  margin: 0;
  color: ${BASIC_DARK_GRAY};
  font-size: 14px;
  font-weight: 300;
  line-height: 1.8em;
  margin-bottom: 2em;
  text-align: center;
`;

const ModalSubtitle = styled.div`
  padding: 0;
  margin: 0 0 10px;
  line-height: 2em;
  letter-spacing: 0.05em;
  color: ${BASIC_DARK_GRAY};
  text-align: center;
  white-space: pre-line;
  font-size: 16px;
`;

const ModalSubtitleContainer = styled.div`
  margin: 0 20px 15px 20px;
`;
